import React from 'react';
import PropTypes from 'prop-types';
import {Panel} from 'react-bootstrap';
import AssessmentQuestion from './AssessmentQuestion';
import ProgressBarItem from './ProgressBar';

class AssessmentSection extends React.Component {

  constructor(props) {
    super(props);

    let answered = [];
    if (props.answers) {
      answered = Object.keys(props.answers).reduce((res, a) => {
        props.subsection.questions.forEach(q => {
          if (+q[0].question_id === +a) {
            res.push(+a);
          }
        });
        return res;
      }, []);
    }

    this.state = {
      answered,
    };
  }

  onQuestionSelect = async (qId, aId) => {
    if (!this.state.answered.includes(qId)) {
      this.setState((prevState) => ({
        answered: [...prevState.answered, qId]
      }));
    }

    await this.props.onQuestionSelect(qId, aId);
  };

  onPanelExpand = (panel) => {
    panel.scrollIntoView();
    window.scrollBy(0, -105);
  };

  getHeaderStyle = () => {
    if(this.props.disabled) {
      return '';
    }
    else {
      return (
        this.state.answered.length === this.props.subsection.questions.length ?
        'subsection-title color-green' : 'subsection-title color-red'
      );
    }
  };

  render() {
    const questions = this.props.subsection.questions.map(q => {
      return (
        <AssessmentQuestion
          averageScores={this.props.averageScores}
          key={q[0].question_id}
          question={q}
          answer={this.props.answers[q[0].question_id]}
          disabled={this.props.disabled}
          onSelect={this.onQuestionSelect}
          handleComment={this.props.handleComment}/>
      );
    });

    return (
      <Panel eventKey={this.props.subsection.name}>
          <Panel.Heading>
            <Panel.Title toggle>
              <div className={this.getHeaderStyle()}>
                <div className={'subsection-name'}> {this.props.subsection.name}
                <div data-cy="sub-progress-bar" style={{width: '200px', float: 'right'}}>
                    {this.props.subScore ?
                      <ProgressBarItem
                        placement={'right'}
                        score={this.props.subScore}
                        width={'200px'}/> : null}
                </div>
                </div>
                { !this.props.disabled &&
                  <p><b>{this.state.answered.length} / {this.props.subsection.questions.length}</b></p>
                }
              </div>
            </Panel.Title>
          </Panel.Heading>
        <Panel.Collapse onEntered={this.onPanelExpand}>
          <Panel.Body>
            {questions}
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    );
  }
}

AssessmentSection.propTypes = {
  subsection: PropTypes.object.isRequired,
  onQuestionSelect: PropTypes.func,
  handleComment: PropTypes.func,
  onPanelExpand: PropTypes.func,
  answers: PropTypes.object,
  disabled: PropTypes.bool,
  averageScores: PropTypes.bool,
  subScore: PropTypes.number
};

export default AssessmentSection;



// WEBPACK FOOTER //
// ./src/components/teams/AssessmentSection.js